import React, { ReactElement } from "react";
import { AgencyMemberId } from "../../../messages";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { MESSAGE_SVG } from "../../../utils/svgs";
import { AppBottomSheet, AppBottomSheetProps } from "../../Generic/AppBottomSheet";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import { AppIcon } from "../../Generic/AppIcon";
import { AppListItem } from "../../Generic/AppList";
import { If } from "../../Generic/If";
import { AgencyBlock } from "../AgenciesListUtils";
import { AgencyListItemAgencyMemberRow } from "./AgencyListItemAgencyMemberRow";

interface Props extends AppBottomSheetProps {
  isOpen: boolean;
  agency: AgencyBlock;
  activeDepartment?: string;
  onClickDepartment: (department: string) => void;
  onClickAgencyMember: (agencyMemberId: AgencyMemberId) => void;
  onRequestClose: () => void;
}

export function ChatWithAgencyBottomSheet(props: Props): ReactElement {
  return (
    <AppBottomSheet
      {...props}
      className="ChatWithAgencyBottomSheet"
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
    >
      {props.agency.contactableAgencyMembers.map((block) => (
        <React.Fragment key={block.department}>
          <If condition={props.activeDepartment === undefined}>
            <AppCard onClick={() => props.onClickDepartment(block.department)}>
              <AppCardContent>
                <AppListItem
                  leading={<AppIcon icon={MESSAGE_SVG} fill="black" />}
                  title={translate(STRINGS.CONTACT) + " " + block.department}
                />
              </AppCardContent>
            </AppCard>
          </If>

          <If condition={props.activeDepartment === block.department}>
            {block.agencyMembers
              .filter((member) => member.status === "Active")
              .map((member) => (
                <AgencyListItemAgencyMemberRow
                  key={member.id.toString()}
                  member={member}
                  onClick={() => props.onClickAgencyMember(member.id)}
                />
              ))}
          </If>
        </React.Fragment>
      ))}
    </AppBottomSheet>
  );
}
